import { RootStore, withInjectedRootStore } from 'providers';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Text } from '@wix/design-system';
import s from './ShowCaseFeatures.scss';
import { RealEstateId, Step } from 'enums';
import { JsonMap, ShowCaseItem } from 'types';
import { RevShareSubtitle } from '../RevShareSubtitle/RevShareSubtitle';

const ShowCaseFeaturesComp: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const {
    appContext: { parsedDealerOffers },
    isEligibleForRevShare,
    currentStep,
  } = rootStore.appStore;
  const offeringShowCaseItems: JsonMap<any> = parsedDealerOffers.get(
    RealEstateId.WixStudioShowCaseItems,
  );

  const shouldShowRevShareSubtitle = isEligibleForRevShare && currentStep !== Step.Plans;

  if (shouldShowRevShareSubtitle) {
    return <RevShareSubtitle />;
  }


  const { t } = useTranslation();

  if (!offeringShowCaseItems || !Object.values(offeringShowCaseItems).length) {
    return <></>;
  }
  const itemsToRender: ShowCaseItem[] = Object.values(offeringShowCaseItems)
    .filter((item) => item?.order)
    .sort((a, b) => a?.order - b?.order);

  return (
    <Box gap='SP3'>
      <Text className={s.semiBold}>
        {t('studio_package_picker.header.studio_benefits.title')}
      </Text>
      {itemsToRender.map(({ titleTranslationKey, iconImg }) => (
        <Box verticalAlign='middle' gap='SP1' key={titleTranslationKey}>
          <img src={iconImg} alt={titleTranslationKey} />
          <Text className={s.bold}>{t(titleTranslationKey)}</Text>
        </Box>
      ))}
    </Box>
  );
};

export const ShowCaseFeatures = withInjectedRootStore(ShowCaseFeaturesComp);
